import { render, staticRenderFns } from "./editorImage.vue?vue&type=template&id=6b8bb87b&scoped=true"
import script from "./editorImage.vue?vue&type=script&lang=js"
export * from "./editorImage.vue?vue&type=script&lang=js"
import style0 from "./editorImage.vue?vue&type=style&index=0&id=6b8bb87b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8bb87b",
  null
  
)

export default component.exports